import { EMixpanelSLTPType } from '../../types';

export const getMixpanelSLTPType = (SLTPType: EMixpanelSLTPType | undefined) => {
  if (SLTPType === EMixpanelSLTPType.SL || SLTPType === EMixpanelSLTPType.TEMP_SL) {
    return EMixpanelSLTPType.SL;
  } else if (SLTPType === EMixpanelSLTPType.TP || SLTPType === EMixpanelSLTPType.TEMP_TP) {
    return EMixpanelSLTPType.TP;
  } else {
    return undefined;
  }
};

export const checkIsModifyTracking = (SLTPType: EMixpanelSLTPType | undefined) => {
  if (
    SLTPType === EMixpanelSLTPType.SL ||
    SLTPType === EMixpanelSLTPType.TP ||
    SLTPType === EMixpanelSLTPType.ENTRY ||
    SLTPType === EMixpanelSLTPType.STOP_LIMIT
  ) {
    return true;
  } else {
    return false;
  }
};
